import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const PackageRowAddComponent = ({ show, onAdd, priority }) => {
  if (!onAdd) return null;
  if (!show) return null;

  return (
    <div className="col mt-4">
      <div className="card border h-100 d-flex align-items-center justify-content-center">
        <button className="btn btn-sm btn-primary" onClick={onAdd}>
          <FontAwesomeIcon
            icon={faPlus}
            className="holidaySprite hotelCardCalendar"
          />{" "}
          Add Priority {priority}
        </button>
      </div>
    </div>
  );
};

export default PackageRowAddComponent;
